import { DocumentAutofillNavItem } from '@/common/types/components.def.ts'
import { Region } from '@/common/types/region-config.def.ts'
import React from 'react'

// Australia
const AuIntern = React.lazy(() => import('@/pages/document-autofill/contracts/australia/au-intern.tsx'))
const AuNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/australia/au-non-investment.tsx'))
const AuShort = React.lazy(() => import('@/pages/document-autofill/contracts/australia/au-short.tsx'))
const AuLong = React.lazy(() => import('@/pages/document-autofill/contracts/australia/au-long.tsx'))
const AuSeparationWithNoticeContract = React.lazy(() => import('@/pages/document-autofill/offboarding/australia/au-separation-with-notice.tsx'))
const AuSeparationWithoutNoticeContract = React.lazy(() => import('@/pages/document-autofill/offboarding/australia/au-separation-without-notice.tsx'))
const AuSydneyEmploymentCertificateResignationContract = React.lazy(() => import('@/pages/document-autofill/letter-templates/australia/au-sydney-employment-certificate-resignation.tsx'))
const AuMelbourneEmploymentCertificateResignationContract = React.lazy(() => import('@/pages/document-autofill/letter-templates/australia/au-melbourne-employment-certification-resignation'))
const AuProbationExtension = React.lazy(() => import('@/pages/document-autofill/letter-templates/australia/au-probation-extension.tsx'))

// China
const CnIntern = React.lazy(() => import('@/pages/document-autofill/contracts/china/cn-intern.tsx'))
const CnNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/china/cn-non-investment.tsx'))
const CnShort = React.lazy(() => import('@/pages/document-autofill/contracts/china/cn-short.tsx'))
const CnLong = React.lazy(() => import('@/pages/document-autofill/contracts/china/cn-long.tsx'))
const CnSeparationWithNoticeContract = React.lazy(() => import('@/pages/document-autofill/offboarding/china/cn-separation-with-notice.tsx'))
const CnSeparationWithoutNoticeContract = React.lazy(() => import('@/pages/document-autofill/offboarding/china/cn-separation-without-notice.tsx'))
const CnShEmploymentCertificate = React.lazy(() => import('@/pages/document-autofill/letter-templates/china/cn-sh-employment-certificate.tsx'))
const CnShEmploymentCertificateResignationContract = React.lazy(() => import('@/pages/document-autofill/letter-templates/china/cn-sh-employment-certificate-resignation.tsx'))
const CnBjEmploymentCertificateResignationContract = React.lazy(() => import('@/pages/document-autofill/letter-templates/china/cn-bj-employment-certificate-resignation.tsx'))

// Hong Kong
const HkIntern = React.lazy(() => import('@/pages/document-autofill/contracts/hong-kong/hk-intern.tsx'))
const HkNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/hong-kong/hk-non-investment.tsx'))
const HkShort = React.lazy(() => import('@/pages/document-autofill/contracts/hong-kong/hk-short.tsx'))
const HkLong = React.lazy(() => import('@/pages/document-autofill/contracts/hong-kong/hk-long.tsx'))
const HkFixedTermEmploymentContract = React.lazy(() => import('@/pages/document-autofill/contracts/hong-kong/hk-fixed-term-employment.tsx'))
const HkSeparationIntern = React.lazy(() => import('@/pages/document-autofill/offboarding/hong-kong/hk-separation-intern.tsx'))
const HkSeparationWithNoticeContract = React.lazy(() => import('@/pages/document-autofill/offboarding/hong-kong/hk-separation-with-notice.tsx'))
const HkSeparationWithoutNoticeContract = React.lazy(() => import('@/pages/document-autofill/offboarding/hong-kong/hk-separation-without-notice.tsx'))
const HkConsentLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-consent-letter.tsx'))
const HkProbationExtension = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-probation-extension.tsx'))
const HkShiftArrangement = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-shift-arrangement.tsx'))
const HkEmploymentCertificate = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-employment-certificate.tsx'))
const HkEmploymentCertificateResignation = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-employment-certificate-resignation.tsx'))
const HkApecCardEmploymentLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-apec-card-employment-letter.tsx'))
const HkDomesticHelperLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-domestic-helper-letter.tsx'))
const HkEmploymentCertificateVisaLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-employment-certificate-visa-letter.tsx'))
const HkIncomeVerificationEmploymentCertificate = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-income-verification-employment-certificate-letter.tsx'))
const HkIncomeVerificationLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/hong-kong/hk-income-verification-letter.tsx'))

// Japan
const JpIntern = React.lazy(() => import('@/pages/document-autofill/contracts/japan/jp-intern.tsx'))
const JpNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/japan/jp-non-investment.tsx'))
const JpNonInvestmentRehireAfterRetirement = React.lazy(() => import('@/pages/document-autofill/contracts/japan/jp-non-investment-rehire-after-retirement.tsx'))
const JpShort = React.lazy(() => import('@/pages/document-autofill/contracts/japan/jp-short.tsx'))
const JpLong = React.lazy(() => import('@/pages/document-autofill/contracts/japan/jp-long.tsx'))
const JpSeparationIntern = React.lazy(() => import('@/pages/document-autofill/offboarding/japan/jp-separation-intern.tsx'))
const JpSeparationResignation = React.lazy(() => import('@/pages/document-autofill/offboarding/japan/jp-separation-resignation.tsx'))
const JpSeparationWithNoticePay = React.lazy(() => import('@/pages/document-autofill/offboarding/japan/jp-separation-with-notice-pay.tsx'))
const JpSeparationWithoutNoticePay = React.lazy(() => import('@/pages/document-autofill/offboarding/japan/jp-separation-without-notice-pay.tsx'))
const JpMutualSeparation = React.lazy(() => import('@/pages/document-autofill/offboarding/japan/jp-mutual-separation.tsx'))
const JpProbationExtension = React.lazy(() => import('@/pages/document-autofill/letter-templates/japan/jp-probation-extension.tsx'))
const JpEmploymentCertificateResignation = React.lazy(() => import('@/pages/document-autofill/letter-templates/japan/jp-employment-certificate-resignation.tsx'))
const JpEmploymentCertificate = React.lazy(() => import('@/pages/document-autofill/letter-templates/japan/jp-employment-certificate.tsx'))
const JpEmploymentCertificateJpLanguage = React.lazy(() => import('@/pages/document-autofill/letter-templates/japan/jp-employment-certificate-jp-language.tsx'))

// Korea
const KrIntern = React.lazy(() => import('@/pages/document-autofill/contracts/korea/kr-intern.tsx'))
const KrNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/korea/kr-non-investment.tsx'))
const KrShort = React.lazy(() => import('@/pages/document-autofill/contracts/korea/kr-short.tsx'))
const KrLong = React.lazy(() => import('@/pages/document-autofill/contracts/korea/kr-long.tsx'))
const KrSeparationWithNotice = React.lazy(() => import('@/pages/document-autofill/offboarding/korea/kr-separation-with-notice.tsx'))

// Singapore
const SgIntern = React.lazy(() => import('@/pages/document-autofill/contracts/singapore/sg-intern.tsx'))
const SgNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/singapore/sg-non-investment.tsx'))
const SgShort = React.lazy(() => import('@/pages/document-autofill/contracts/singapore/sg-short.tsx'))
const SgLong = React.lazy(() => import('@/pages/document-autofill/contracts/singapore/sg-long.tsx'))
const SgMacroPm = React.lazy(() => import('@/pages/document-autofill/contracts/singapore/sg-macro-pm.tsx'))
const SgSeparationIntern = React.lazy(() => import('@/pages/document-autofill/offboarding/singapore/sg-separation-intern.tsx'))
const SgSeparationWithNotice = React.lazy(() => import('@/pages/document-autofill/offboarding/singapore/sg-separation-with-notice.tsx'))
const SgSeparationWithoutNotice = React.lazy(() => import('@/pages/document-autofill/offboarding/singapore/sg-separation-without-notice.tsx'))
const SgProbationExtension = React.lazy(() => import('@/pages/document-autofill/letter-templates/singapore/sg-probation-extension.tsx'))
const SgEmploymentCertificateResignation = React.lazy(() => import('@/pages/document-autofill/letter-templates/singapore/sg-employment-certificate-resignation.tsx'))
const SgApecCardEmploymentLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/singapore/sg-apec-card-employment-letter.tsx'))
const SgEmploymentCertificate = React.lazy(() => import('@/pages/document-autofill/letter-templates/singapore/sg-employment-certificate.tsx'))
const SgEmploymentCertificateIndianEmbassy = React.lazy(() => import('@/pages/document-autofill/letter-templates/singapore/sg-employment-certificate-indian-embassy.tsx'))

// Taiwan
const TwIntern = React.lazy(() => import('@/pages/document-autofill/contracts/taiwan/tw-intern.tsx'))
const TwNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/taiwan/tw-non-investment.tsx'))
const TwNonInvestmentFixedTerm = React.lazy(() => import('@/pages/document-autofill/contracts/taiwan/tw-non-investment-fixed-term.tsx'))
const TwShort = React.lazy(() => import('@/pages/document-autofill/contracts/taiwan/tw-short.tsx'))
const TwLong = React.lazy(() => import('@/pages/document-autofill/contracts/taiwan/tw-long.tsx'))
const TwSeparationResignation = React.lazy(() => import('@/pages/document-autofill/offboarding/taiwan/tw-separation-resignation.tsx'))
const TwSeparationWithNotice = React.lazy(() => import('@/pages/document-autofill/offboarding/taiwan/tw-separation-with-notice.tsx'))
const TwSeparationWithoutNotice = React.lazy(() => import('@/pages/document-autofill/offboarding/taiwan/tw-separation-without-notice.tsx'))
const TwProbationExtension = React.lazy(() => import('@/pages/document-autofill/letter-templates/taiwan/tw-probation-extension.tsx'))
const TwEmploymentCertificateResignation = React.lazy(() => import('@/pages/document-autofill/letter-templates/taiwan/tw-employment-certificate-resignation.tsx'))

// United States
const UsIntern = React.lazy(() => import('@/pages/document-autofill/contracts/united-states/us-intern.tsx'))
const UsQuantResearcher = React.lazy(() => import('@/pages/document-autofill/contracts/united-states/us-quant-researcher.tsx'))
const UsNonExemptNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/united-states/us-non-exempt-non-investment.tsx'))
const UsExemptNonInvestment = React.lazy(() => import('@/pages/document-autofill/contracts/united-states/us-exempt-non-investment.tsx'))
const UsShort = React.lazy(() => import('@/pages/document-autofill/contracts/united-states/us-short.tsx'))
const UsLong = React.lazy(() => import('@/pages/document-autofill/contracts/united-states/us-long.tsx'))
const UsSeparationResignation = React.lazy(() => import('@/pages/document-autofill/offboarding/united-states/us-separation-resignation.tsx'))
const UsSeparationTermination = React.lazy(() => import('@/pages/document-autofill/offboarding/united-states/us-separation-termination.tsx'))
const UsProbationExtension = React.lazy(() => import('@/pages/document-autofill/letter-templates/united-states/us-probation-extension.tsx'))
const UsEmploymentCertificateResignation = React.lazy(() => import('@/pages/document-autofill/letter-templates/united-states/us-employment-certificate-resignation.tsx'))
const UsEmploymentCertificate = React.lazy(() => import('@/pages/document-autofill/letter-templates/united-states/us-employment-certificate.tsx'))

// Global
const GlobalEmploymentChangeLetter = React.lazy(() => import('@/pages/document-autofill/letter-templates/global/employment-change-letter.tsx'))
const StatementOfDeferredAmountNoPayment = React.lazy(() => import('@/pages/document-autofill/letter-templates/global/statement-of-deferred-amount-no-payment.tsx'))
const StatementOfDeferredAmountWithPayment = React.lazy(() => import('@/pages/document-autofill/letter-templates/global/statement-of-deferred-amount-with-payment.tsx'))
const StatementOnExceptionalAwardsAmountTemplate = React.lazy(() => import('./letter-templates/global/statement-on-exceptional-award-amount'))

export const documentAutofillNavConfig: DocumentAutofillNavItem[] = [
  {
    label: 'Australia',
    pathValue: 'australia',
    region: Region.Australia,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <AuIntern /> },
          { label: 'Non-Investment', pathValue: 'non-investment', element: <AuNonInvestment /> },
          { label: 'Analyst', pathValue: 'short', element: <AuShort /> },
          { label: 'PM', pathValue: 'long', element: <AuLong /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          {
            label: 'Separation With Notice',
            pathValue: 'separation-with-notice',
            element: <AuSeparationWithNoticeContract />,
          },
          {
            label: 'Separation Without Notice',
            pathValue: 'separation-without-notice',
            element: <AuSeparationWithoutNoticeContract />,
          },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          { label: 'Probation Extension', pathValue: 'probation-extension', element: <AuProbationExtension /> },
          {
            label: 'Sydney Employment Certificate Resignation',
            pathValue: 'sydney-employment-certificate-resignation',
            element: <AuSydneyEmploymentCertificateResignationContract />,
          },
          {
            label: 'Melbourne Employment Certificate Resignation',
            pathValue: 'melbourne-employment-certification-resignation',
            element: <AuMelbourneEmploymentCertificateResignationContract />,
          },
        ],
      },
    ],
  },
  {
    label: 'China',
    pathValue: 'china',
    region: Region.China,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <CnIntern /> },
          {
            label: 'Non-Investment',
            pathValue: 'non-investment',
            element: <CnNonInvestment />,
          },
          { label: 'Analyst', pathValue: 'short', element: <CnShort /> },
          { label: 'PM', pathValue: 'long', element: <CnLong /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          {
            label: 'Separation With Notice',
            pathValue: 'separation-with-notice',
            element: <CnSeparationWithNoticeContract />,
          },
          {
            label: 'Separation Without Notice',
            pathValue: 'separation-without-notice',
            element: <CnSeparationWithoutNoticeContract />,
          },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          {
            label: 'Shanghai Employment Certificate',
            pathValue: 'sh-employment-certificate',
            element: <CnShEmploymentCertificate />,
          },
          {
            label: 'Shanghai Employment Certificate - Resignation',
            pathValue: 'sh-employment-certificate-resignation',
            element: <CnShEmploymentCertificateResignationContract />,
          },
          {
            label: 'Beijing Employment Certificate - Resignation',
            pathValue: 'bj-employment-certificate-resignation',
            element: <CnBjEmploymentCertificateResignationContract />,
          },
        ],
      },
    ],
  },
  {
    label: 'Hong Kong',
    pathValue: 'hong-kong',
    region: Region.HongKong,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <HkIntern /> },
          { label: 'Non-Investment', pathValue: 'non-investment', element: <HkNonInvestment /> },
          { label: 'Analyst', pathValue: 'short', element: <HkShort /> },
          { label: 'PM', pathValue: 'long', element: <HkLong /> },
          { label: 'Fixed Term Employment', pathValue: 'fix-term-employment', element: <HkFixedTermEmploymentContract /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          { label: 'Separation Intern', pathValue: 'separation-intern', element: <HkSeparationIntern /> },
          {
            label: 'Separation With Notice',
            pathValue: 'separation-with-notice',
            element: <HkSeparationWithNoticeContract />,
          },
          {
            label: 'Separation Without Notice',
            pathValue: 'separation-without-notice',
            element: <HkSeparationWithoutNoticeContract />,
          },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          { label: 'Consent Letter', pathValue: 'consent-letter', element: <HkConsentLetter /> },
          { label: 'Probation Extension', pathValue: 'probation-extension', element: <HkProbationExtension /> },
          { label: 'Shift Arrangement', pathValue: 'shift-arrangement', element: <HkShiftArrangement /> },
          {
            label: 'Employment Certificate',
            pathValue: 'employment-certificate',
            element: <HkEmploymentCertificate />,
          },
          {
            label: 'Employment Certificate Resignation',
            pathValue: 'employment-certificate-resignation',
            element: <HkEmploymentCertificateResignation />,
          },
          {
            label: 'APEC Card Employment Letter',
            pathValue: 'apec-card-employment-letter',
            element: <HkApecCardEmploymentLetter />,
          },
          { label: 'Domestic Helper Letter', pathValue: 'domestic-helper-letter', element: <HkDomesticHelperLetter /> },
          {
            label: 'Employment Certificate Visa Letter',
            pathValue: 'employment-certificate-visa-letter',
            element: <HkEmploymentCertificateVisaLetter />,
          },
          {
            label: 'Income Verification Employment Certificate',
            pathValue: 'income-verification-employment-certificate-letter',
            element: <HkIncomeVerificationEmploymentCertificate />,
          },
          {
            label: 'Income Verification Letter',
            pathValue: 'income-verification-letter',
            element: <HkIncomeVerificationLetter />,
          },
        ],
      },
    ],
  },
  {
    label: 'Japan',
    pathValue: 'japan',
    region: Region.Japan,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <JpIntern /> },
          { label: 'Non-Investment', pathValue: 'non-investment', element: <JpNonInvestment /> },
          {
            label: 'Non-Investment Rehire After Retirement',
            pathValue: 'non-investment-rehire-after-retirement',
            element: <JpNonInvestmentRehireAfterRetirement />,
          },
          { label: 'Analyst', pathValue: 'short', element: <JpShort /> },
          { label: 'PM', pathValue: 'long', element: <JpLong /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          { label: 'Separation Intern', pathValue: 'separation-intern', element: <JpSeparationIntern /> },
          {
            label: 'Separation Resignation',
            pathValue: 'separation-resignation',
            element: <JpSeparationResignation />,
          },
          {
            label: 'Separation With Notice Pay',
            pathValue: 'separation-with-notice-pay',
            element: <JpSeparationWithNoticePay />,
          },
          {
            label: 'Separation Without Notice Pay',
            pathValue: 'separation-without-notice-pay',
            element: <JpSeparationWithoutNoticePay />,
          },
          { label: 'Mutual Separation', pathValue: 'mutual-separation', element: <JpMutualSeparation /> },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          { label: 'Probation Extension', pathValue: 'probation-extension', element: <JpProbationExtension /> },
          {
            label: 'Employment Certificate Resignation',
            pathValue: 'employment-certificate-resignation',
            element: <JpEmploymentCertificateResignation />,
          },
          {
            label: 'Employment Certificate',
            pathValue: 'employment-certificate',
            element: <JpEmploymentCertificate />,
          },
          {
            label: 'Employment Certificate JP Language',
            pathValue: 'employment-certificate-jp-language',
            element: <JpEmploymentCertificateJpLanguage />,
          },
        ],
      },
    ],
  },
  {
    label: 'Korea',
    pathValue: 'korea',
    region: Region.Korea,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <KrIntern /> },
          { label: 'Non-Investment', pathValue: 'non-investment', element: <KrNonInvestment /> },
          { label: 'Analyst', pathValue: 'short', element: <KrShort /> },
          { label: 'PM', pathValue: 'long', element: <KrLong /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          { label: 'Separation With Notice', pathValue: 'separation-with-notice', element: <KrSeparationWithNotice /> },
        ],
      },
    ],
  },
  {
    label: 'Singapore',
    pathValue: 'singapore',
    region: Region.Singapore,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <SgIntern /> },
          { label: 'Non-Investment', pathValue: 'non-investment', element: <SgNonInvestment /> },
          { label: 'Analyst', pathValue: 'short', element: <SgShort /> },
          { label: 'PM', pathValue: 'long', element: <SgLong /> },
          { label: 'Macro PM', pathValue: 'macro-pm', element: <SgMacroPm /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          { label: 'Separation Intern', pathValue: 'separation-intern', element: <SgSeparationIntern /> },
          { label: 'Separation With Notice', pathValue: 'separation-with-notice', element: <SgSeparationWithNotice /> },
          {
            label: 'Separation Without Notice',
            pathValue: 'separation-without-notice',
            element: <SgSeparationWithoutNotice />,
          },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          { label: 'Probation Extension', pathValue: 'probation-extension', element: <SgProbationExtension /> },
          {
            label: 'Employment Certificate Resignation',
            pathValue: 'employment-certificate-resignation',
            element: <SgEmploymentCertificateResignation />,
          },
          {
            label: 'APEC Card Employment Letter',
            pathValue: 'apec-card-employment-letter',
            element: <SgApecCardEmploymentLetter />,
          },
          {
            label: 'Employment Certificate',
            pathValue: 'employment-certificate',
            element: <SgEmploymentCertificate />,
          },
          {
            label: 'Employment Certificate Indian Embassy',
            pathValue: 'employment-certificate-indian-embassy',
            element: <SgEmploymentCertificateIndianEmbassy />,
          },
        ],
      },
    ],
  },
  {
    label: 'Taiwan',
    pathValue: 'taiwan',
    region: Region.Taiwan,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <TwIntern /> },
          { label: 'Non-Investment', pathValue: 'non-investment', element: <TwNonInvestment /> },
          {
            label: 'Non-Investment Fixed Term',
            pathValue: 'non-investment-fixed-term',
            element: <TwNonInvestmentFixedTerm />,
          },
          { label: 'Analyst', pathValue: 'short', element: <TwShort /> },
          { label: 'PM', pathValue: 'long', element: <TwLong /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          {
            label: 'Separation Resignation',
            pathValue: 'separation-resignation',
            element: <TwSeparationResignation />,
          },
          { label: 'Separation With Notice', pathValue: 'separation-with-notice', element: <TwSeparationWithNotice /> },
          {
            label: 'Separation Without Notice',
            pathValue: 'separation-without-notice',
            element: <TwSeparationWithoutNotice />,
          },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          { label: 'Probation Extension', pathValue: 'probation-extension', element: <TwProbationExtension /> },
          {
            label: 'Employment Certificate Resignation',
            pathValue: 'employment-certificate-resignation',
            element: <TwEmploymentCertificateResignation />,
          },
        ],
      },
    ],
  },
  {
    label: 'United States',
    pathValue: 'united-states',
    region: Region.UnitedStates,
    subGroups: [
      {
        label: 'Employment Contract',
        pathValue: 'contracts',
        children: [
          { label: 'Intern', pathValue: 'intern', element: <UsIntern /> },
          { label: 'Quant Researcher', pathValue: 'quant-researcher', element: <UsQuantResearcher /> },
          {
            label: 'Non Exempt Non-Investment',
            pathValue: 'non-exempt-non-investment',
            element: <UsNonExemptNonInvestment />,
          },
          { label: 'Exempt Non-Investment', pathValue: 'exempt-non-investment', element: <UsExemptNonInvestment /> },
          { label: 'Analyst', pathValue: 'short', element: <UsShort /> },
          { label: 'PM', pathValue: 'long', element: <UsLong /> },
        ],
      },
      {
        label: 'Offboarding',
        pathValue: 'offboarding',
        children: [
          {
            label: 'Separation Resignation',
            pathValue: 'separation-resignation',
            element: <UsSeparationResignation />,
          },
          {
            label: 'Separation Without Notice',
            pathValue: 'separation-termination',
            element: <UsSeparationTermination />,
          },
        ],
      },
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          { label: 'Probation Extension', pathValue: 'probation-extension', element: <UsProbationExtension /> },
          {
            label: 'Employment Certificate Resignation',
            pathValue: 'employment-certificate-resignation',
            element: <UsEmploymentCertificateResignation />,
          },
          {
            label: 'Employment Certificate',
            pathValue: 'employment-certificate',
            element: <UsEmploymentCertificate />,
          },
        ],
      },
    ],
  },
  {
    label: 'Global',
    pathValue: 'global',
    region: Region.Global,
    subGroups: [
      {
        label: 'Letter Template',
        pathValue: 'letter-templates',
        children: [
          {
            label: 'Employment Change Letter',
            pathValue: 'employment-change-letter',
            element: <GlobalEmploymentChangeLetter />,
          },
          {
            label: 'Statement of Deferred Amount With No Payment',
            pathValue: 'statement-of-deferred-amount-with-no-payment',
            element: <StatementOfDeferredAmountNoPayment />,
          },
          {
            label: 'Statement of Deferred Amount With Payment',
            pathValue: 'statement-of-deferred-amount-with-payment',
            element: <StatementOfDeferredAmountWithPayment />,
          },
          {
            label: 'Statement on Exceptional Award Amount',
            pathValue: 'statement-on-exceptional-award-amount',
            element: <StatementOnExceptionalAwardsAmountTemplate/>
          }
        ],
      },
    ],
  },
]
